import React, { useEffect, useState } from 'react';
import { FiMail } from 'react-icons/fi';
import { RiLockPasswordLine } from 'react-icons/ri';
import { Link, useNavigate } from 'react-router-dom';
import Nav from '../../components/Navigation/Nav';
import Footer from '../../Pages/Footer/Footer';
import bg from '../../assets/images/BG.png';
import tree from '../../assets/images/tree.png';
import private_share from '../../assets/images/private-family-sharing.png';
import animated from '../../assets/images/HomePageTree-animation.gif';
import privacy from '../../assets/images/your-privacy.png';
import "../Landing/Landing.css"





const Landing = () => {


  return (
    <div  className="outer-body"style={{ backgroundImage: `url(${bg})`}}>
      <Nav />

      <div className="container-fluid" style={{ paddingBottom: '15%' }}>
        <div className="row" style={{ marginTop: '10%' }}>
          <div className="col-md-6">
            <h1 className="landing-title" style={{ marginTop: '15%' }}>Enrich your<br />family life</h1><br />
            <h2 className="landing-content">Connect securely with your extended family, share traditions and memories
              for future generations.
              <br />
              <br />
              {/* <button className="btn signupbtn" style={{ position: 'relative', marginLeft: '10%' }} data-toggle="modal" data-target="#myModal">Click to Sign Up</button> */}
            </h2>
          </div>
          <div className="col-md-6">
            <img src={tree} alt="Tree" className="landing-image" />
          </div>
        </div>
      </div>

      <div className="container-fluid" style={{ paddingBottom: '15%' }}>
        <div className="row">
          <div className="col-md-6">
            <img src={animated} alt="Tree Animation" className="landing-image" />
          </div>
          <div className="col-md-6">
            <h1 className="landing-title">Simple and<br />well connected<br /> family tree</h1><br />
            <h2 className="landing-content">Build your family tree, invite your family members and keep yourself well
              informed about your extended family, all within your own family space.
            </h2>
          </div>
        </div>
      </div>


      <div className="container-fluid" style={{ paddingBottom: '15%' }}>
        <div className="row">
          <div className="col-md-6">
            <h1 className="landing-title">A safe and private<br />family sharing space</h1><br />
            <h2 className="landing-content">Narrate your stories, journey of your ancestors, share photos, videos and
              joyful moments of your little ones all on one single platform.
            </h2>
          </div>
          <div className="col-md-6">
            <img src={private_share} alt="Private Family Sharing" className="landing-image" />
          </div>
        </div>
      </div>



      <div className="container-fluid" style={{ paddingBottom: '15%' }}>
        <div className="row">
          <div className="col-md-6">
            <img src={privacy} alt="Your Privacy" className="landing-image" />
          </div>
          <div className="col-md-6">
            <h1 className="landing-title">Your privacy</h1><br />
            <h2 className="landing-content">
              Our vision is to provide a secure platform for you and your family to share information with people you already know, trust, and care.
              <br /><br />
              Your privacy and data protection are very important to us. We assure you that we will never share your personal data or monetize it in any way.
            </h2>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default Landing